exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3qQKi{height:53px;border-radius:2px;margin-bottom:8px;font-size:19px;display:block;overflow:hidden;border:1px solid #dbdbdb;background-color:#fff;color:#484848;line-height:24px;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-image:linear-gradient(45deg,transparent 50%,gray 0),linear-gradient(135deg,gray 50%,transparent 0);background-position:calc(100% - 15px) calc(50% + 2px),calc(100% - 15px) calc(1em + 2px),calc(100% - 2.5em) .5em;background-size:5px 6px,5px 6px,1px 1.5em;background-repeat:no-repeat}", ""]);

// exports
exports.locals = {
	"formControlSelect": "_3qQKi"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/LanguageSwitcher/LanguageSwitcher.css
// module id = 2540
// module chunks = 15